var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoLisatingPlaceholder = function SvgNoLisatingPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 162
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M64.806 161.324h-.675c0-17.558-14.205-31.792-31.728-31.792-17.523 0-31.728 14.234-31.728 31.792H0c0-17.932 14.507-32.468 32.403-32.468 17.895 0 32.403 14.536 32.403 32.468zm234.92 0h-.675c0-17.558-14.205-31.792-31.728-31.792-17.522 0-31.727 14.234-31.727 31.792h-.675c0-17.932 14.507-32.468 32.402-32.468 17.896 0 32.403 14.536 32.403 32.468zm-79.319-77.449h-.675c0-32.076-26.044-58.171-58.055-58.171-32.012 0-58.055 26.095-58.055 58.17h-.675c0-32.448 26.346-58.847 58.73-58.847s58.73 26.4 58.73 58.848z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.111,
    cy: 13.359,
    fill: "#111A37",
    fillOpacity: 0.2,
    rx: 13.332,
    ry: 13.359
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m51.943 105.311 22.905-27.332h45.033l27.52 26.859-.556.358h.198v55.866H51.974v-55.866z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M70.917 93.428h-5.192V75.419h5.192z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "m74.491 77.621 28.234 33.168v50.273H51.974V104.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M85.836 117.372h10.365v10.619H85.836zm0 14.449h10.365v10.619H85.836z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M85.836 117.372h10.365v10.619H85.836zm0 14.449h10.365v10.619H85.836z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M71.501 117.372h10.365v10.619H71.501zm0 14.449h10.365v10.619H71.501z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M71.501 117.372h10.365v10.619H71.501zm0 14.449h10.365v10.619H71.501z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M57.167 117.372h10.365v10.619H57.167zm0 14.449h10.365v10.619H57.167z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M57.167 117.372h10.365v10.619H57.167zm0 14.449h10.365v10.619H57.167z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M163.702 13.528h4.725v11.837h-4.725z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M127.924 24.351h40.166v136.973h-40.166z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M168.09 24.351h16.201v136.973H168.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M135.181 36.188h6.076v6.088h-6.076zm9.788 0h6.076v6.088h-6.076zm9.788 0h6.076v6.088h-6.076zm-19.408 13.866h6.076v6.088h-6.076zm9.789 0h6.076v6.088h-6.076zm9.788 0h6.076v6.088h-6.076zm-19.408 13.867h6.076v6.088h-6.076zm9.788 0h6.076v6.088h-6.076zm9.789 0h6.076v6.088h-6.076zm-19.408 13.866h6.076v6.088h-6.076zm9.788 0h6.076v6.088h-6.076zm9.789 0h6.076v6.088h-6.076zm-19.408 13.866h6.076v6.088h-6.076zm9.788 0h6.076v6.088h-6.076zm9.788 0h6.076v6.088h-6.076zm-19.408 13.867h6.076v6.088h-6.076zm9.789 0h6.076v6.088h-6.076zm9.788 0h6.076v6.088h-6.076zm-19.408 13.866h6.076v6.088h-6.076zm9.789 0h6.076v6.088h-6.076zm9.788 0h6.076v6.088h-6.076zm-19.408 13.867h6.076v6.088h-6.076zm9.788 0h6.076v6.088h-6.076zm0 16.233h6.076v11.499h-6.076zm9.789-16.233h6.076v6.088h-6.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M168.09 13.528h2.7v11.499h-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M214.331 73.729h4.725v7.016h-4.725z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    d: "M178.553 80.143h40.166v81.181h-40.166z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M218.719 80.143h16.201v81.181h-16.201z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M186.485 91.653h6.076v6.088h-6.076zm9.788 0h6.076v6.088h-6.076zm9.789 0h6.076v6.088h-6.076zm-19.408 13.867h6.076v6.088h-6.076zm9.788 0h6.076v6.088h-6.076zm9.789 0h6.076v6.088h-6.076zm-19.408 13.866h6.076v6.088h-6.076zm9.788 0h6.076v6.088h-6.076zm9.788 0h6.076v6.088h-6.076zm-19.408 13.867h6.076v6.088h-6.076zm9.789 0h6.076v6.088h-6.076zm0 16.233h6.076v11.499h-6.076zm9.788-16.233h6.076v6.088h-6.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M218.719 73.729h2.7v6.815h-2.7zM.082 160.915h299.726v1H.082z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.294,
    cy: 136.648,
    fill: "#37A3BC",
    rx: 8.789,
    ry: 8.807
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M253.832 130.766a8.816 8.816 0 0 1-3.37 10.897 8.776 8.776 0 0 1-11.275-1.576 8.788 8.788 0 0 0 7.98 5.345 8.788 8.788 0 0 0 8.102-5.156 8.82 8.82 0 0 0-1.437-9.51z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M247.318 136.649h.025l.434 24.969h-.917z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m248.717 149.864.202.385-1.453.766-.203-.385z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.135,
    cy: 123.647,
    fill: "#37A3BC",
    rx: 13.366,
    ry: 13.393
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M283.078 114.702c2.575 6.036.405 13.052-5.125 16.57a13.346 13.346 0 0 1-17.147-2.395 13.367 13.367 0 0 0 12.135 8.128 13.363 13.363 0 0 0 12.321-7.842 13.412 13.412 0 0 0-2.184-14.46z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M273.172 123.647h.037l.66 37.971h-1.395z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m275.298 143.744.308.586-2.21 1.166-.307-.587z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.998,
    cy: 136.31,
    fill: "#37A3BC",
    rx: 8.789,
    ry: 8.807
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.537 130.428a8.818 8.818 0 0 1-3.37 10.897 8.778 8.778 0 0 1-11.276-1.576 8.79 8.79 0 0 0 7.98 5.345 8.787 8.787 0 0 0 8.102-5.157 8.823 8.823 0 0 0-1.436-9.51z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M9.023 136.31h.024l.434 24.97h-.917z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "m10.42 149.526.203.385-1.453.767-.203-.386zM204.682 12.627l3.108-2.49c-2.414-.267-3.406 1.052-3.812 2.096-1.886-.784-3.939.244-3.939.244l6.217 2.261a4.706 4.706 0 0 0-1.574-2.11zM48.744 25.14l3.107-2.49c-2.414-.266-3.406 1.053-3.812 2.097-1.885-.785-3.938.244-3.938.244l6.217 2.261a4.71 4.71 0 0 0-1.574-2.111zm203.193 12.852 3.107-2.49c-2.414-.266-3.406 1.053-3.812 2.097-1.886-.785-3.938.243-3.938.243l6.216 2.262a4.717 4.717 0 0 0-1.573-2.112zM74.396 18.377l3.107-2.49c-2.414-.267-3.405 1.052-3.811 2.096-1.886-.785-3.939.243-3.939.243l6.217 2.262a4.71 4.71 0 0 0-1.574-2.111zm5.738 27.056 3.107-2.49c-2.414-.267-3.405 1.052-3.811 2.096-1.886-.784-3.939.244-3.939.244l6.217 2.261a4.716 4.716 0 0 0-1.574-2.111zM200.97 59.638l3.107-2.49c-2.414-.267-3.406 1.052-3.812 2.096-1.886-.785-3.938.243-3.938.243l6.216 2.262a4.709 4.709 0 0 0-1.573-2.111zM35.778 154.221H14.851v.677h3.264v6.426h.675v-6.426h12.712v6.426h.675v-6.426h3.601zm21.265 2.706c-.826 0-1.638.218-2.353.632a5.048 5.048 0 0 0-5.446-.871 5.065 5.065 0 0 0-3.002 4.636H61.75a4.726 4.726 0 0 0-4.708-4.397zm79.994 0c-.826 0-1.637.218-2.352.632a5.05 5.05 0 0 0-5.447-.871 5.068 5.068 0 0 0-3.002 4.636h15.51a4.726 4.726 0 0 0-4.709-4.397zm52.317 0c-.826 0-1.637.218-2.352.632a5.05 5.05 0 0 0-5.447-.871 5.068 5.068 0 0 0-3.002 4.636h15.51a4.726 4.726 0 0 0-4.709-4.397zm68.856 0c-.826 0-1.637.218-2.352.632a5.05 5.05 0 0 0-5.447-.871 5.068 5.068 0 0 0-3.002 4.636h15.51a4.726 4.726 0 0 0-4.709-4.397zm33.078 0c-.826 0-1.637.218-2.352.632a5.05 5.05 0 0 0-5.447-.871 5.068 5.068 0 0 0-3.002 4.636h15.51a4.726 4.726 0 0 0-4.709-4.397zM43.541 137.649h-5.4v5.412h2.503v18.233h.675v-18.233h2.222zm-28.649 14.549h20.927v1H14.892zm0-1.691h20.927v1H14.892zm0-1.691h20.927v1H14.892z"
  }))));
};
export default SvgNoLisatingPlaceholder;